import './sentry';  // configuration de Sentry

import React, { useEffect, useMemo, useState } from "react";
import { Navigate, useNavigate } from 'react-router-dom';

import {Container, IconButton, Drawer, useMediaQuery, Breadcrumbs, Link, Grid, Box, Button, Snackbar, Alert, Typography, Stack, Radio} from '@mui/material'

import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';

// import useStyles from './styles.js'

import './styles/global.css';

import CloseIcon from '@mui/icons-material/Close';


// import logo from './images/logo.png'
import MainContainer from "./components/mainContainer/MainContainer.js";

import ActuMainContainer from "./components/actualite/MainContainer.js";
import { Outlet, Route, Routes, useLocation} from "react-router-dom";
import LiveMatch from "./components/Live/LiveMatch.js";
import HomeAdmin from "./components/admin/AdminHome.js";
import PostMatch from "./components/matchs/postMatch/PostMatchs.js";
import { useDispatch, useSelector } from "react-redux";
import { checkUser, getToken, getUser, isAdminDSAS, isAdminUser, logoutUser } from "./actions/auth.js";
import useSessionCheck from "./hooks/useSessionCheck.js";

import Login from "./components/auth/LoginPage.js";
import Notifications from "./Notifications.js";
import PlayersCSV from "./components/admin/csv/PlayersCSV.js";
import TeamsCSV from "./components/admin/csv/TeamsCSV.js";
import MatchesCSV from "./components/admin/csv/MatchesCSV.js";
import IndexMultiSport from "./v2/pages/IndexMultiSport.js";
import Sports from "./v2/pages/sports/Sports.js";
import MultisportCalendarCSV from "./components/admin/csv/MultisportCalendarCSV.js";
import Events from "./v2/pages/events/Events.js";
import LivePage from "./v2/pages/events/lives/LivePage.js";
import GetLives from "./v2/pages/events/lives/get/GetLives.js";
import FormLive from "./v2/pages/events/lives/create/FormLive.js";
import Actors from "./v2/pages/actors/Actors.js";
import PlayerPage from "./v2/pages/actors/players/PlayerPage.js";
import GetPlayers from "./v2/pages/actors/players/get/GetPlayers.js";
import FormPlayer from "./v2/pages/actors/players/create/FormPlayer.js";
import TeamPage from "./v2/pages/actors/teams/TeamPage.js";
import GetTeams from "./v2/pages/actors/teams/get/GetTeams.js";
import FormTeam from "./v2/pages/actors/teams/create/FormTeam.js";
import CalendarResolver from "./v2/pages/events/lives/saisie/multiplex/LiveCollectCalendar.js";
import EditPlayer from "./v2/pages/actors/players/edit/EditPlayer.js";
import EditTeam from "./v2/pages/actors/teams/edit/EditTeam.js";
import WebhookDataSync from "./v2/admin/datasync/WebhookDataSync.js";
import ActorsCSV from "./components/admin/csv/ActorsCSV.js";
import CompetitionPage from "./v2/pages/events/competitions/CompetitionPage.js";
import GetCompetitions from "./v2/pages/events/competitions/get/GetCompetitions.js";
import CompetitionResolver from "./v2/pages/events/competitions/create/CompetitionResolver.js";

import IndexPlayers from './v1/pages/players/IndexPlayers.js';
import GetTransfers from './v1/pages/transfers/GetTransfers.jsx';
import GetPlayersV1 from './v1/pages/players/get/GetPlayers.js';
import EditPlayerV1 from './v1/pages/players/edit/EditPlayer.js';
import FormPlayerV1 from './v1/pages/players/create/FormPlayer.js';
import EditPlayers from './v1/pages/players/thirdparty/EditPlayers.js';

import IndexTeams from './v1/pages/teams/IndexTeams.js';
import GetTeamsV1 from './v1/pages/teams/get/GetTeams.js';
import EditTeamV1 from './v1/pages/teams/edit/EditTeam.js';
import FormTeamV1 from './v1/pages/teams/create/FormTeam.js';
import EditTeams from './v1/pages/teams/thirdparty/EditTeams.js';

import IndexCompetitions from './v1/pages/competitions/IndexCompetitions.js';
import GetCompetitionsV1 from './v1/pages/competitions/get/GetCompetitions.js';
import EditCompetitionV1 from './v1/pages/competitions/edit/EditCompetition.js';
import FormCompetitionV1 from './v1/pages/competitions/create/FormCompetition.js';
import ApisDataSync from './v2/admin/datasync/ApisDataSync.js';
import MergePlayersPage from './v1/pages/players/merge/MergePlayer.js';
import EnvironmentExportMergeLauncher from './v1/pages/players/merge/EnvironmentExportMergeLauncher.js';
import BullBoardView from './v2/admin/datasync/BullBoardView.js';
import FixJobsView from './v2/admin/datasync/FixJobsView.js';

import DirectSocketManager from './v1/pages/direct/DirectSocketManager.js';
import DirectDatesResolver from './v1/pages/direct/DirectDatesResolver.js';
import DirectDetailResolver from './v1/pages/direct/DirectDetailResolver.js';
import MultiplexResolver from './v1/pages/direct/multiplex/MultiplexResolver.js';
import MatchResolver from './v1/pages/direct/match/MatchResolver.js';

import useStyles from './styles/global-mui.js';
import DsasButton from './v1/components/DsasButton/DsasButton.js';
import logo from './images/dsas/logo.svg';
import ProtectedRoute from './permissions/ProtectedRoute.js';
import { PERMISSIONS } from './permissions/permissionKeys.js';
import { Can } from './permissions/Can.js';
import DevUserSwitcher from './permissions/DevUserSwitcher.js';
import DirectActuDetailResolver from './v1/pages/direct/DirectActuDetailResolver.js';
import ActuResolver from './v1/pages/direct/actualite/ActuResolver.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import SousMenuItem from './v1/components/Menu/SousMenuItem.js';
import { usePermissions } from './permissions/usePermissions.js';
import CalendarCSV from './components/admin/csv/CalendarCSV.js';
import ApiManager from './v1/admin/ApiManager.js';
import CacheManager from './v1/admin/CacheManager.js';
import WidgetCacheManager from './v1/admin/WidgetCacheManager.js';
import EnvironmentExport from './components/admin/environment/EnvironmentExport.js';
import EnvironmentImport from './components/admin/environment/EnvironmentImport.js';
import EnvironmentImportReports from './components/admin/environment/EnvironmentImportReports.js';
import EnvironmentImportReportDetail from './components/admin/environment/EnvironmentImportReportDetail.js';

// Composant qui lève une erreur pour tester Sentry
const ErrorTest = () => {
    // Lever une erreur dès que le composant est rendu
    throw new Error("Sentry Frontend Client Test Error");
  };

const App = () => {

    const [drawerOpen, setDrawerOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const { getPermission } = usePermissions()

    const classes = useStyles();

    const dispatch = useDispatch()

    const location = useLocation(); // Récupère l'URL actuelle

    const navigate = useNavigate();

    const currentPath = location.pathname;
    const transferQuery = new URLSearchParams();
    const currentQuery = new URLSearchParams(location.search);
    ['discipline', 'season'].forEach(key => {
        if (currentQuery.get(key)) transferQuery.set(key, currentQuery.get(key));
    });
    const transfersPath = `/sports/transfers${transferQuery.toString() ? `?${transferQuery.toString()}` : ''}`;

    // Vérifie si le chemin commence par "/divers/"
    const isDivers = location?.pathname?.startsWith("/divers") || location?.pathname?.startsWith("/actualites");
    const isJO = location?.pathname?.startsWith("/multisport");

    // const currentUser = useSelector(state => state.authentication.currentUser)

    const currentUser = useSelector(state => state.authentication.currentUser);
    const loggedIn = useSelector(state => state.authentication.loggedIn);

    const [checkingUser, setCheckingUser] = useState(true);

        useEffect(() => {
        const verify = async () => {
            await dispatch(checkUser());
            setCheckingUser(false);
        };

        verify();
        }, []);

    // État pour gérer l'affichage de la notification et l'attente de la déconnexion
    const [open, setOpen] = useState();
    const [notificationMessage, setNotificationMessage] = useState("");

    // useEffect(() => {
    //     //Auchargement, on va checker la clef en localstorage
    //     // S'il y a une clef, on valorise le user redux avec le /checkUser
    //     dispatch(checkUser());

    // }, []);

    const user = getUser();
    const token = getToken();

    // useEffect(() => {
    //     if (user && token && location.pathname === '/lives') {
    //         navigate('/sports/lives', { replace: true });
    //     }
    // }, [user, token, location.pathname]);

    const logout = () => dispatch(logoutUser())

    // Utilisation du hook pour vérifier l'expiration de la session
    useSessionCheck(setNotificationMessage, setOpen);

    //Body alternative for login page
    useEffect(() => {
    const isLoginPage = !getUser() || !getToken();

    if (isLoginPage) {
        document.body.classList.add('body-login');
    } else {
        document.body.classList.remove('body-login');
    }

    // Nettoyage si le composant se démonte
    return () => {
        document.body.classList.remove('body-login');
    };
}, [location.pathname, getUser(), getToken()]);

const breadcrumbLinks = [
  {
    label: 'Directs',
    href: '/sports/lives',
    permission: PERMISSIONS.SPORT_LIVES_HOME_PAGE,
    isActive: (path) => path.startsWith('/sports/lives'),
  },
  {
    label: 'Match',
    href: '/match',
    permission: PERMISSIONS.SPORT_MATCH_HOME_PAGE,
    isActive: (path) => path === '/match',
  },
  {
    label: 'Match Management',
    href: '/matchmanagement',
    permission: PERMISSIONS.SPORT_MATCHMANAGEMENT_HOME_PAGE,
    isActive: (path) => path === '/matchmanagement',
  },
  {
    label: 'Compétitions',
    href: '/sports/competitions',
    permission: PERMISSIONS.SPORT_COMPETITION_HOME_PAGE,
    isActive: (path) => path.startsWith('/sports/competitions'),
  },
  {
    label: 'Equipes',
    href: '/sports/teams',
    permission: PERMISSIONS.SPORT_TEAM_HOME_PAGE,
    isActive: (path) => path.startsWith('/sports/teams'),
  },
  {
    label: 'Joueurs',
    href: '/sports/players',
    permission: PERMISSIONS.SPORT_PLAYER_HOME_PAGE,
    isActive: (path) => path.startsWith('/sports/players'),
  },
  {
    label: 'Transferts',
    href: transfersPath,
    permission: PERMISSIONS.SPORT_PLAYER_HOME_PAGE,
    isActive: (path) => path.startsWith('/sports/transfers'),
  },
  {
    label: 'Calendriers',
    href: '/sports/calendriers',
    permission: PERMISSIONS.SPORT_CALENDAR_HOME_PAGE,
    isActive: (path) => path.startsWith('/sports/calendriers'),
  },
  {
    label: 'Résultats',
    href: '/results',
    permission: PERMISSIONS.SPORT_RESULT_HOME_PAGE,
    isActive: (path) => path === '/results',
  },
];

const visibleLinks = useMemo(
  () =>
    breadcrumbLinks.filter(({ permission }) => {
        const result = getPermission(permission)
        return result?.allowed

    }
    ),
  [currentUser]
);

if (checkingUser) {
  return null; // ou un spinner
}

if (!currentUser || !loggedIn || !getToken()) {
  return <Login />;
}
    // Condition pour afficher la page de login si non authentifié
    // if(!getUser() || !getToken())
    //     return (
    //         <Login/>
    //     )

    return (
        <Container maxWidth='100%' className='app-container medium-padding'>
            <DevUserSwitcher />
            <Notifications/>
            {/* Snackbar pour les notifications de session */}
            <Snackbar 
            open={open} 
            autoHideDuration={null} 
            onClose={() => setOpen(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpen(false)} severity="warning" sx={{ width: '100%' }}>
                    {notificationMessage}
                </Alert>
            </Snackbar>

            
            
            <Routes>  
                <Route path="/lives" element={<Navigate to="/sports/lives" replace />} />
                
                <Route path={"/*"} element={
                <>
                {/*PAGE HEADER*/}
                <Box className='page-header' position="static" color="inherit">
                   
                    <Grid container sx={{alignItems: 'stretch'}}>
                        {/*USERNAME SECTION*/}
                        <Grid item xs={4.5}>
                            <Box className='medium-padding display-grid' sx={{justifyItems: 'left'}}>
                            <p className='username'>{currentUser.sub}</p>
                             {isMobile && <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                onClick={() => setDrawerOpen(true)}
                                sx={{ p:0, m:0, mt:'10px' }}
                                >
                                <MenuIcon />
                                </IconButton>}
                            </Box>
                        </Grid>
                         {/*LOGO*/}
                        <Grid item xs={3} className='logo-wrapper'>
                            <img className='logo' src={logo} alt="Logo"/>
                        </Grid>
                        {/*ADMIN DASHBOARD LINK*/}
                        <Grid item xs={4.5}>
                            <Box className='admin-nav subtitle medium-padding'>
                                {isAdminDSAS() && <Link href="/admin">ADMIN</Link>}
                                <Button
                                    onClick={logout}
                                    startIcon={<FontAwesomeIcon icon={faRightFromBracket} />}
                                    size="small"
                                    sx={{justifyContent: "right", marginTop: '10px'}}
                                    >
                                    {!isMobile && 'Se déconnecter'}
                                    </Button>
                                {/* <Button onClick={logout}>Se déconnecter</Button> */}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            {/*MENU BUTTONS*/}
                    {isMobile ? (
                            <Box>

                            <Drawer
                                anchor="left"
                                open={drawerOpen}
                                onClose={() => setDrawerOpen(false)}
                                ModalProps={{ keepMounted: true }}
                                sx={{
                                    '& .MuiDrawer-paper': {
                                    width: '100%',
                                    maxWidth: '75%',
                                    p: 2,
                                    borderRadius: '8px',
                                    },
                                }}
                                >
                                <Box sx={{ width: '100%' }}>
                                    {/* Close Icon */}
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <IconButton onClick={() => setDrawerOpen(false)}>
                                        <CloseIcon />
                                    </IconButton>
                                    </Box>

                                    {/* MENU PRINCIPAL */}
                                    <Box sx={{ bgcolor: 'var(--color-light-grey)', p: 2, borderRadius: 2, mb: 2 }}>
                                    <Typography variant="subtitle1" sx={{ mb: 1, color:'var(--color-dark-grey)' }}>
                                        MENU PRINCIPAL
                                    </Typography>
                                    <Stack spacing={1}>
                                        <Box
                                        onClick={() => navigate('/divers/lives')}
                                        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                        >
                                        <Radio
                                            checked={isDivers}
                                            value="actualites"
                                            size="small"
                                            sx={{ p: 0, pr: 1,
                                                color: isDivers ? 'var(--color-blue-primary)' : 'var(--color-dark-grey)',
                                                '&.Mui-checked': {
                                                    color: 'var(--color-blue-primary)',
                                                },
                                             }}
                                        />
                                        <Typography
                                        sx={{
                                        color: isDivers ? 'var(--color-blue-primary)' : 'var(--color-text)',
                                        }}
                                        >Actualités</Typography>
                                        </Box>
                                        <Box
                                        onClick={() => navigate('/sports/lives')}
                                        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                        >
                                        <Radio
                                            checked={!isDivers && !isJO}
                                            value="sport"
                                            size="small"
                                            sx={{ p: 0, pr: 1,
                                                color: (!isDivers && !isJO) ? 'var(--color-blue-primary)' : 'var(--color-dark-grey)',
                                                 '&.Mui-checked': {
                                                    color: 'var(--color-blue-primary)',
                                                },
                                             }}
                                        />
                                        <Typography
                                        sx={{
                                        color: (!isDivers && !isJO) ? 'var(--color-blue-primary)' : 'var(--color-text)',
                                        }}
                                        >Sports</Typography>
                                        </Box>
                                        {isAdminUser() && (
                                        <Box
                                            onClick={() => navigate('/multisport')}
                                            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                        >
                                            <Radio
                                            checked={isJO}
                                            value="jo"
                                            size="small"
                                            sx={{ p: 0, pr: 1,
                                                color: isJO ? 'var(--color-blue-primary)' : 'var(--color-dark-grey)',
                                                 '&.Mui-checked': {
                                                    color: 'var(--color-blue-primary)',
                                                },
                                             }}
                                            />
                                            <Typography
                                            sx={{
                                                color: isJO ? 'var(--color-blue-primary)' : 'var(--color-text)',
                                                }}
                                            >JO 2024</Typography>
                                        </Box>
                                        )}
                                    </Stack>
                                    </Box>

                                    {/* SOUS MENU */}
                                    <Box sx={{p:2}}>
                                    {!isJO &&
                                    <Typography variant="subtitle1" sx={{ mb: 1, color:'var(--color-dark-grey)' }}>
                                        SOUS MENU
                                    </Typography>}
                                    { !isDivers && !isJO &&
                                        <Stack spacing={1}>
                                        <SousMenuItem label="Directs" path="/sports/lives" setDrawerOpen={setDrawerOpen} />
                                        <SousMenuItem label="Match" path="/match" setDrawerOpen={setDrawerOpen}/>
                                        <SousMenuItem label="Match Management" path="/matchmanagement" setDrawerOpen={setDrawerOpen} />
                                        <SousMenuItem label="Compétitions" path="/sports/competitions" setDrawerOpen={setDrawerOpen} />
                                        <SousMenuItem label="Equipes" path="/sports/teams" setDrawerOpen={setDrawerOpen} />
                                        <SousMenuItem label="Joueurs" path="/sports/players" setDrawerOpen={setDrawerOpen} />
                                        <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_PAGE}>
                                            <SousMenuItem label="Transferts" path={transfersPath} setDrawerOpen={setDrawerOpen} />
                                        </Can>
                                        <SousMenuItem label="Calendrier" path="/sports/calendriers" setDrawerOpen={setDrawerOpen} />
                                        <SousMenuItem label="Résultats" path="/results" setDrawerOpen={setDrawerOpen} />
                                    </Stack>}
                                     { isDivers &&
                                        <Stack spacing={1}>
                                        <SousMenuItem label="Directs" path="/divers/lives" setDrawerOpen={setDrawerOpen} />
                                        <SousMenuItem label="Actus" path="/divers/actualite" setDrawerOpen={setDrawerOpen} />
                                        <SousMenuItem label="Catégories" path="/divers/category" setDrawerOpen={setDrawerOpen} />
                                    </Stack>}
                                    </Box>
                                </Box>
                                </Drawer>
                            </Box>
                            ) : (
                            <Box className='menu-container xl-padding-left xl-padding-right'> 
                                <Box className='centered-medium-wrapper'>
                                    <DsasButton label="Actualités" onClick={() => navigate('/divers/lives')} variant='primary' focused={isDivers} />
                                    <DsasButton label="Sports" onClick={() => navigate('/sports/lives')} variant='primary' focused={!isDivers && !isJO} />
                                    {isAdminUser() &&
                                    <DsasButton label="JO 2024" onClick={() => navigate('/multisport')} variant='primary' focused={isJO} />
                                    }
                                </Box>
                                <Box className='medium-separator'></Box>
                            </Box>
                            )}
                    
{/* {!isMobile && <> */}
            {/*NAVIGATION*/}
            <Box className='nav-container xl-padding-left xl-padding-right'>  
                        {isDivers &&
                        <>
                            <Box className='centered-medium-wrapper'>
                                <Breadcrumbs aria-label="breadcrumb" className={classes.breadcrumbNav}>
                                    <Link 
                                        underline="hover" 
                                        color={(currentPath.startsWith('/divers/lives') || currentPath.startsWith('/actualites/lives')) ? 'primary' : 'inherit'}
                                        className={(currentPath.startsWith('/divers/lives') || currentPath.startsWith('/actualites/lives')) ? 'breadcrumb-active' : ''}
                                        href="/divers/lives">
                                            Directs
                                        </Link>
                                    {isAdminDSAS() && 
                                        <Link 
                                        underline="hover" 
                                        color={currentPath.startsWith('/divers/actualite') ? 'primary' : 'inherit'}
                                        className={currentPath.startsWith('/divers/actualite') ? 'breadcrumb-active' : ''}
                                        href="/divers/actualite">
                                            Actus
                                        </Link>}
                                    {isAdminDSAS() && 
                                        <Link 
                                        underline="hover" 
                                        color={currentPath.startsWith('/divers/category') ? 'primary' : 'inherit'}
                                        className={currentPath.startsWith('/divers/category') ? 'breadcrumb-active' : ''}
                                        href="/divers/category">
                                            Catégories
                                        </Link>}
                                </Breadcrumbs>
                            </Box>
                            <Box className='medium-separator'></Box>
                            </>
                        }
                        {!isDivers && !isJO &&
                        <>
                            <Box className='centered-medium-wrapper'>
                                <Breadcrumbs aria-label="breadcrumb" className={classes.breadcrumbNav} maxItems={Math.max(visibleLinks.length, 1)}>
                                    {visibleLinks.map(({ label, href, isActive }) => (
                                        <Link
                                        key={href}
                                        underline="hover"
                                        href={href}
                                        color={isActive(currentPath) ? 'primary' : 'inherit'}
                                        className={isActive(currentPath) ? 'breadcrumb-active' : ''}
                                        >
                                        {label}
                                        </Link>
                                    ))}
                                </Breadcrumbs>
                            </Box>
                            <Box className='medium-separator'></Box>
                            </>
                        }
            </Box>
            {/* </>
                } */}
                    
            <Box className='pages-container xl-padding-left xl-padding-right'>           
            <Routes>

                 {/* Route qui génère une erreur pour tester Sentry */}
                 <Route path="/debug-sentry" element={<ErrorTest />} />

                <Route
                    path="/admin"
                    element={
                        <ProtectedRoute permission={PERMISSIONS.SPORT_ADMIN_HOME_PAGE}>
                            <Outlet />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<HomeAdmin />} />
                    <Route path="csv/players" element={<PlayersCSV />} />
                    <Route path="csv/teams" element={<TeamsCSV />} />
                    <Route path="csv/matches" element={<MatchesCSV />} />
                    <Route path="csv/multisport/calendar" element={<MultisportCalendarCSV />} />
                    <Route path="csv/multisport/actors" element={<ActorsCSV />} />
                    <Route path="environment-export" element={<EnvironmentExport />} />
                    <Route path="environment-import" element={<EnvironmentImport />} />
                    <Route path="environment-import/reports" element={<EnvironmentImportReports />} />
                    <Route path="environment-import/reports/:id" element={<EnvironmentImportReportDetail />} />
                    <Route path="manager/api_data" element={<ApiManager />} />
                    <Route path="manager/cacheconfigs" element={<CacheManager />} />
                    <Route path="manager/cacheconfigs/widgets" element={<WidgetCacheManager />} />
                    <Route path="datasync/webhook/send" element={<WebhookDataSync />} />
                    <Route path="datasync/apis/:service" element={<ApisDataSync />} />
                    <Route path="datasync/jobs" element={<BullBoardView />} />
                    <Route path="datasync/jobs/fix" element={<FixJobsView />} />
                </Route>

                <Route path="/admin/csv/players" element={<PlayersCSV />} />

                <Route path="/admin/csv/calendar" element={<CalendarCSV />} />

                {/* REFONTE V1 */}
                <Route path="/sports" element={<Outlet />}>
                    <Route path="transfers" element={<ProtectedRoute permission={PERMISSIONS.SPORT_PLAYER_HOME_PAGE}><GetTransfers /></ProtectedRoute>} />
                    {/* Routes imbriquées */}
                    <Route path="players" element={<IndexPlayers/>}>
                            <Route index element={<ProtectedRoute permission={PERMISSIONS.SPORT_PLAYER_HOME_PAGE}><GetPlayersV1/></ProtectedRoute>} />
                            <Route path="merge" element={<ProtectedRoute permission={PERMISSIONS.SPORT_PLAYER_FUSION_PAGE}><MergePlayersPage/></ProtectedRoute>} />
                            <Route path="merge/from-export" element={<ProtectedRoute permission={PERMISSIONS.SPORT_PLAYER_FUSION_PAGE}><EnvironmentExportMergeLauncher/></ProtectedRoute>} />
                            <Route path="create" element={<ProtectedRoute permission={PERMISSIONS.SPORT_PLAYER_CREATE_PAGE}><FormPlayerV1/></ProtectedRoute>} />
                            <Route path="create/:id" element={<ProtectedRoute permission={PERMISSIONS.SPORT_PLAYER_EDIT_PAGE}><EditPlayerV1/></ProtectedRoute>} />
                            <Route path="thirdparty/:thirdPartyId/:thirdPartyEntityId" element={<ProtectedRoute permission={PERMISSIONS.SPORT_PLAYER_MULTIEDIT_PAGE}><EditPlayers/></ProtectedRoute>} />
                    </Route>
                    {/* Routes imbriquées */}
                    <Route path="teams" element={<IndexTeams/>}>
                            <Route index element={<ProtectedRoute permission={PERMISSIONS.SPORT_TEAM_HOME_PAGE}><GetTeamsV1/></ProtectedRoute>} />
                            <Route path="create" element={<ProtectedRoute permission={PERMISSIONS.SPORT_TEAM_CREATE_PAGE}><FormTeamV1/></ProtectedRoute>} />
                            <Route path="create/:id" element={<ProtectedRoute permission={PERMISSIONS.SPORT_TEAM_EDIT_PAGE}><EditTeamV1/></ProtectedRoute>} />
                            <Route path="thirdparty/:thirdPartyId/:thirdPartyEntityId" element={<ProtectedRoute permission={PERMISSIONS.SPORT_TEAM_MULTIEDIT_PAGE}><EditTeams/></ProtectedRoute>} />
                    </Route>
                    {/* Routes imbriquées */}
                    <Route path="competitions" element={<IndexCompetitions/>}>
                            <Route index element={<ProtectedRoute permission={PERMISSIONS.SPORT_COMPETITION_HOME_PAGE}><GetCompetitionsV1/></ProtectedRoute>} />
                            <Route path="create" element={<ProtectedRoute permission={PERMISSIONS.SPORT_COMPETITION_CREATE_PAGE}><FormCompetitionV1/></ProtectedRoute>} />
                            <Route path="create/:id" element={<ProtectedRoute permission={PERMISSIONS.SPORT_COMPETITION_EDIT_PAGE}><EditCompetitionV1/></ProtectedRoute>} />
                            {/*<Route path="thirdparty/:thirdPartyId/:thirdPartyEntityId" element={<EditCompetitions/>} />*/}
                    </Route>
                    <Route exact path="lives/:id" element={<ProtectedRoute permission={PERMISSIONS.SPORT_LIVE_HOME_PAGE}><DirectSocketManager/></ProtectedRoute>} >
                        <Route path=":mode" element={<DirectDatesResolver />} >
                            <Route path=":date" element={<DirectDetailResolver />} >
                                <Route path="" element={<MultiplexResolver />}>
                                    <Route path=":idMatch" element={<MatchResolver />} />
                                </Route>
                            </Route>
                        </Route>
                    </Route>
                    <Route exact path="actualites/lives/:id" element={<DirectSocketManager/>} >
                        <Route path="" element={<DirectActuDetailResolver />} >
                                <Route path=":idMatch" element={<MatchResolver />} />
                        </Route>
                    </Route>
                </Route>
                <Route path="/actualites" element={<Outlet />}>
                    <Route path="lives/:id" element={<DirectSocketManager/>} >
                        <Route path="" element={<DirectActuDetailResolver />} >
                                <Route path=":actu" element={<ActuResolver />} />
                        </Route>
                    </Route>
                </Route>

                {/* MULTI SPORT */}
                <Route path="/multisport" element={<Outlet />}>
                    {/* Routes imbriquées */}
                    <Route index element={<IndexMultiSport/>} />
                    <Route path="sports" element={<Sports/>} />
                    <Route path="actors" element={<Actors/>}>
                        <Route path="players" element={<PlayerPage/>}>
                            <Route index element={<GetPlayers/>} />
                            <Route path="create" element={<FormPlayer/>} />
                            <Route path="create/:id" element={<EditPlayer/>} />
                        </Route>
                        <Route path="teams" element={<TeamPage/>}>
                            <Route index element={<GetTeams/>} />
                            <Route path="create" element={<FormTeam/>} />
                            <Route path="create/:id" element={<EditTeam/>} />
                        </Route>
                    </Route>
                    <Route path="events" element={<Events/>}>
                        <Route path="lives" element={<LivePage/>}>
                            <Route index element={<GetLives/>} />
                            <Route path="create" element={<FormLive/>} />
                            <Route path="collect/:idLive/calendar" element={<CalendarResolver/>}/>
                            <Route path="collect/:idLive/calendar/:date" element={<CalendarResolver/>}/>  
                        </Route>
                        <Route path="competitions" element={<CompetitionPage/>}>
                            <Route index element={<GetCompetitions/>} />
                            <Route path="view/:idCompetition" element={<CompetitionResolver/>}/>
                        </Route>
                        <Route path="matchs" element={<div>Affiche les rencontres</div>} />
                    </Route>
                </Route>

                <Route exactpath={"/lives/*"} element={<Link underline="hover" color="inherit" href="/match" align="right">QUITTER</Link>}></Route>
            </Routes>
                


                <Routes>
                    {/* OLD ROUTE*/}
                    <Route path={"/competition"} element={<MainContainer/>}></Route>
                    <Route path={"/team"} element={<MainContainer/>}></Route>
                    <Route path={"/player"} element={<MainContainer/>}></Route>
                    <Route path={"/divers/*"} element={<ActuMainContainer/>}></Route>
                    <Route path={"/sports/lives"} element={<MainContainer/>}></Route>
                    <Route path={"/lives/:id"} element={<LiveMatch mode='calendar'/>}></Route>
                    <Route path={"/livecompetition/:id"} element={<LiveMatch mode='day'/>}></Route>
                    <Route path={"/divers/lives/:id"} element={<LiveMatch/>}></Route>
                    {/* OLD ROUTE*/}

                    <Route path={"/sports/calendriers"} element={<ProtectedRoute permission={PERMISSIONS.SPORT_CALENDAR_HOME_PAGE}><MainContainer/></ProtectedRoute>}></Route>

                    <Route path={"/match"} element={<ProtectedRoute permission={PERMISSIONS.SPORT_MATCH_HOME_PAGE}><MainContainer/></ProtectedRoute>}></Route>
                    <Route path={"/match/:id"} element={<ProtectedRoute permission={PERMISSIONS.SPORT_MATCH_HOME_PAGE}><PostMatch/></ProtectedRoute>}></Route>
                    <Route path={"/matchmanagement"} element={<ProtectedRoute permission={PERMISSIONS.SPORT_MATCHMANAGEMENT_HOME_PAGE}><MainContainer/></ProtectedRoute>}></Route>
                    <Route path={"/matchmanagement/:id"} element={<ProtectedRoute permission={PERMISSIONS.SPORT_MATCHMANAGEMENT_HOME_PAGE}><MainContainer/></ProtectedRoute>}></Route>
                    <Route path={"/results"} element={<ProtectedRoute permission={PERMISSIONS.SPORT_RESULT_HOME_PAGE}><MainContainer/></ProtectedRoute>}></Route>
                    
                    
                    
                </Routes>

                </Box>
                
                </>}>
                
                </Route>
            </Routes>
        </Container>
    )
}

export default App